import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import { LoadingSpinner, Icon, Text, Button } from 'spindl-shared-components';

import Table from '../../organisms/Table';
import RowExpandedModal from '../../organisms/RowExpandedModal';

import styles from './TableBlock.module.scss';
import usePresenter from './TableBlock.presenter';
import getProps from './TableBlock.props';
import { TableBlockCombinedProps } from './types';
import UserPageBar from '../../molecules/UserPageBar';

// MANUAL OVERRIDE - converted to observer Component
const TableBlock: React.FC<TableBlockCombinedProps> = observer((props) => {
  const {
    state,
    className,
    classes,
    userPageBar,
    table,
    icon,
    title,
    instructions,
    isLoading,
    showModal,
    modalProps,
    clearFiltersButton, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`tableBlock${variantName}`];

  let componentView;

  if (isLoading) {
    return (
      <div className={cx(currentStyle, className)}>
        <LoadingSpinner
          className={cx(styles.loadingSpinner)}
          {...internalProps.loadingSpinner}
          isActive={true}
        />
      </div>
    );
  }
  switch (variantName) {
    case 'Default': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          {/* MANUAL OVERRIDE */}
          <UserPageBar {...userPageBar} />
          {/* MANUAL OVERRIDE */}
          <div className={styles.tableContainer}>
            <Table
              className={cx(styles.table, classes?.table)}
              {...internalProps.table}
              {...table}
            />
          </div>

          {/* MANUAL OVERRIDE */}
          <RowExpandedModal
            modalProps={modalProps}
            className={styles.modalWrapper}
            show={showModal}
          />
        </div>
      );
      break;
    }
    case 'NoResults': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          {/* MANUAL OVERRIDE */}
          <UserPageBar {...userPageBar} />
          <Table
            className={cx(styles.table, classes?.table)}
            {...internalProps.table}
            {...table}
          />
          <div
            className={cx(styles.emptyStateContent, classes?.emptyStateContent)}
          >
            <Icon
              className={cx(styles.icon, classes?.icon)}
              {...internalProps.icon}
              {...icon}
            />
            <div className={cx(styles.content, classes?.content)}>
              <Text
                className={cx(styles.title, classes?.title)}
                {...internalProps.title}
                {...title}
              />
              <Text
                className={cx(styles.instructions, classes?.instructions)}
                {...internalProps.instructions}
                {...instructions}
              />
              {/* MANUAL OVERRIDE */}
              <Button
                className={cx(styles.clearFiltersButton, classes?.clearFiltersButton)}
                {...internalProps.clearFiltersButton}
                {...clearFiltersButton}
              />
            </div>
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }
  return componentView;
}); // MANUAL OVERRIDE

export default TableBlock;
